/*  Shared  */
import i18n from 'i18n';

/*  React  */
import React from 'react';

import { TooltipQ } from '../../Tooltips';

const { t } = i18n;

const filterableOptions = [
    {
        name: t('SSOSupport.filter.available_not_in_use'),
        parameter: 'ssoCoverage',
        render: (
            <>
                {t('SSOSupport.filter.available_not_in_use')}
                <TooltipQ
                    key="tooltip_availableNotInUse"
                    placement="right"
                    text={t('SSOSupport.filter.available_not_in_use.tooltip')}
                />
            </>
        ),
        tooltip: 'risk',
        value: 'availableNotInUse'
    },
    {
        name: t('SSOSupport.filter.at_least_one_detected'),
        parameter: 'ssoCoverage',
        render: t('SSOSupport.filter.at_least_one_detected'),
        value: 'atLeastOneInUse'
    },
    {
        name: t('SSOSupport.filter.unavailable'),
        parameter: 'ssoCoverage',
        render: t('SSOSupport.filter.unavailable'),
        value: 'unavailable'
    }
];

const header = {
    filterable: true,
    filterableOptions,
    key: 'ssoCoverage',
    name: 'Common.ssoSupport',
    sortable: false,
    sortableFieldType: 'string',
    sortKey: 'ssoCoverage',
    squish: true,
    width: '10%'
};

export default header;
